import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import { defineMessage, useIntl } from 'react-intl';
import { FragmentLoggerActionButton } from './FragmentLoggerActionButton';

const goToStreamFromPlaybackMessage = defineMessage({
  id: 'fragments.view.metadata.goToStreamFromPlayback',
  defaultMessage: 'Tiempo actual',
});

type FragmentGoToStreamFromPlaybackActionProps = {
  stationSlug: string;
};

/**
 * Opens logger stream at the current playback timestamp.
 * Stays visible but disabled until playback has a currentTs (avoids layout pop-in).
 */
export function FragmentGoToStreamFromPlaybackAction({
  stationSlug,
}: FragmentGoToStreamFromPlaybackActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const currentTs = usePlaybackCurrentTs();
  const isEnabled = Boolean(currentTs);
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    cursor: currentTs,
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamFromPlayback({
      stationSlug,
      currentTs,
    });
  };

  return (
    <FragmentLoggerActionButton
      to={isEnabled ? loggerStreamUrl : undefined}
      onClick={isEnabled ? handleClick : undefined}
      disabled={!isEnabled}
      startIcon={<LocationSearchingIcon fontSize="small" />}
    >
      {$t(goToStreamFromPlaybackMessage)}
    </FragmentLoggerActionButton>
  );
}
